/* eslint-disable */
require('./circle')
require('./facebook')
require('./heart')
require('./height')
require('./loading')
require('./logo')
require('./messenger')
require('./twitter')
require('./weight')
require('./whatsapp')
